import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Flow Rate Unit List with Query (for remote operations)
export const getFlowRateUnitListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_FLOW_RATE_UNITS}?${stringifyParams(
			params
		)}`
	);
};

// Get Flow Rate Unit List with Query
export const getFlowRateUnitList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
        // populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_FLOW_RATE_UNITS}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Flow Rate Unit
export const getFlowRateUnit = flow_rate_unit_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_FLOW_RATE_UNIT}${flow_rate_unit_id}`
	);
};

// Add New Flow Rate Unit
export const addNewFlowRateUnitApi = flow_rate_unit => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_FLOW_RATE_UNIT}`,
		flow_rate_unit
	);
};

// Update Flow Rate Unit
export const updateFlowRateUnitApi = flow_rate_unit => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_FLOW_RATE_UNIT}${flow_rate_unit._id}`,
		flow_rate_unit
	);
};

// Delete Flow Rate Unit
export const deleteFlowRateUnitApi = flow_rate_unit_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_FLOW_RATE_UNIT}${flow_rate_unit_id}`
	);
};

// Check if Flow Rate Unit Exists
export const checkFlowRateUnitExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_FLOW_RATE_UNIT_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
